import { Icon, type IconName } from './Icon';
import { Mascot, usePlacedMascot } from './Mascot';
import { ICON_SIZE } from '../styles/tokens';
import './EmptyArt.css';

/**
 * El dibujo de un estado vacío (`.empty-state`): la mascota pensando, con el
 * ícono de lo que falta pegado al costado como un sticker. Sin mascota ubicada en
 * el admin, queda el ícono solo en su recuadro. Decorativo.
 */
export function EmptyArt({ icon }: { icon: IconName }) {
  const mascota = usePlacedMascot();
  if (!mascota) {
    return (
      <div className="empty-art-icon" aria-hidden="true">
        <Icon name={icon} size={ICON_SIZE.hero} />
      </div>
    );
  }
  return (
    <div className="empty-art" aria-hidden="true">
      <Mascot mascota={mascota} mood="thinking" framing="bust" />
      <span className="empty-art-sticker">
        <Icon name={icon} size={ICON_SIZE.lg} />
      </span>
    </div>
  );
}
